import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f0ff948")

_pushScopeId("data-v-5f0ff948")
const _hoisted_1 = { class: "main-reverse-page-title" }
const _hoisted_2 = {
  class: "container business-clients",
  id: "clients"
}
const _hoisted_3 = {
  class: "d-none d-lg-flex justify-content-between",
  style: {"align-items":"center"}
}
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "search-button-wrapper pl-15 pr-15" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_7 = { class: "show-all-clear-filter align-items-lg-center pr-15" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "business-clients-filter-circle"
}
const _hoisted_10 = { class: "businessClients-count-block" }
const _hoisted_11 = { class: "business-clients-desktop-actions" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-export fs-18" }, null, -1)
const _hoisted_13 = { class: "d-lg-none d-flex mobile-clients-filter" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-export fs-18" }, null, -1)
const _hoisted_15 = { class: "search-button-wrapper" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_17 = { class: "businessClients-count-block" }
const _hoisted_18 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "business-clients-filter-circle"
}
const _hoisted_21 = { class: "desktop-grid d-none d-lg-block" }
const _hoisted_22 = { class: "w100" }
const _hoisted_23 = { class: "desktop-table-action text-center" }
const _hoisted_24 = { class: "thead-cell-center" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "desktop-table-text-setting" }
const _hoisted_31 = { class: "cuted-cell" }
const _hoisted_32 = { class: "desktop-table-text-setting" }
const _hoisted_33 = { class: "cuted-cell" }
const _hoisted_34 = { class: "desktop-table-action text-center" }
const _hoisted_35 = { class: "mobile-grid d-lg-none" }
const _hoisted_36 = { class: "client-item-row" }
const _hoisted_37 = { class: "client-item-row-title" }
const _hoisted_38 = { class: "client-item-row-value" }
const _hoisted_39 = { class: "client-item-row" }
const _hoisted_40 = { class: "client-item-row-title" }
const _hoisted_41 = { class: "client-item-row-value" }
const _hoisted_42 = { class: "client-item-row" }
const _hoisted_43 = { class: "client-item-row-title" }
const _hoisted_44 = { class: "client-item-row-value" }
const _hoisted_45 = { class: "client-item-row" }
const _hoisted_46 = { class: "client-item-row-title" }
const _hoisted_47 = { class: "client-item-row-value" }
const _hoisted_48 = { class: "client-item-row" }
const _hoisted_49 = { class: "client-item-row-title" }
const _hoisted_50 = { class: "client-item-row-value" }
const _hoisted_51 = { class: "client-item-row" }
const _hoisted_52 = { class: "client-item-row-title" }
const _hoisted_53 = { class: "client-item-row-value" }
const _hoisted_54 = { class: "client-item-row" }
const _hoisted_55 = { class: "client-item-row-title" }
const _hoisted_56 = { class: "client-item-row-value" }
const _hoisted_57 = { class: "client-item-row" }
const _hoisted_58 = { class: "client-item-row-title" }
const _hoisted_59 = { class: "client-item-row-value" }
const _hoisted_60 = { class: "client-item-row" }
const _hoisted_61 = { class: "client-item-row-title" }
const _hoisted_62 = { class: "client-item-row-value" }
const _hoisted_63 = { class: "client-item-row" }
const _hoisted_64 = { class: "client-item-row-title" }
const _hoisted_65 = { class: "c-pointer" }
const _hoisted_66 = { class: "client-item-row-value" }
const _hoisted_67 = { class: "client-item-row" }
const _hoisted_68 = { class: "client-item-row-title" }
const _hoisted_69 = { class: "client-edit-pencil" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('pageTitle.business-clients')), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _withDirectives(_createVNode("input", {
            style: {"min-width":"255px"},
            class: "bookit-input businessClient-input w100",
            id: "datetime",
            type: "text",
            placeholder: _ctx.$t('businessClients.placeholder.search'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.keywords = $event))
          }, null, 8, ["placeholder"]), [
            [_vModelText, _ctx.filter.keywords]
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.GetClients()))
            }, [
              _hoisted_6
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("span", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
            }, _toDisplayString(_ctx.$t('button.showAll')), 1)
          ]),
          _createVNode("div", {
            class: ["business-clients-filter pr-15", { hasFilter: _ctx.hasFilter }]
          }, [
            _createVNode("button", {
              type: "button",
              class: "business-clients-filter-btn-text",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.ShowFilter && _ctx.ShowFilter(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
              _hoisted_8
            ]),
            (_ctx.hasFilter)
              ? (_openBlock(), _createBlock("div", _hoisted_9, "!"))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", null, _toDisplayString(_ctx.$t('businessClient.total-clients')), 1),
            _createVNode("div", null, _toDisplayString(_ctx.$t('businessClient.total-result', [_ctx.totalFiltered, _ctx.total])), 1)
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("button", {
            type: "button",
            class: "businessClient-circle-btn new-businessClient",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.newBusinessClient()))
          }, _toDisplayString(_ctx.$t('businessClient.new')), 1),
          _createVNode("button", {
            type: "button",
            class: "businessClient-circle-btn report-export",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportBusinessClients()))
          }, [
            _hoisted_12,
            _createVNode("div", null, _toDisplayString(_ctx.$t('report.export')), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", null, [
          _createVNode("button", {
            type: "button",
            class: "businessClient-circle-btn new-businessClient",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.newBusinessClient()))
          }, _toDisplayString(_ctx.$t('businessClient.new')), 1),
          _createVNode("button", {
            type: "button",
            class: "businessClient-circle-btn report-export",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportBusinessClients()))
          }, [
            _hoisted_14,
            _createVNode("div", null, _toDisplayString(_ctx.$t('report.export')), 1)
          ])
        ]),
        _createVNode("div", null, [
          _withDirectives(_createVNode("input", {
            style: {"min-width":"255px"},
            class: "bookit-input businessClient-input w100",
            id: "datetime",
            type: "text",
            placeholder: _ctx.$t('businessClients.placeholder.search'),
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.filter.keywords = $event))
          }, null, 8, ["placeholder"]), [
            [_vModelText, _ctx.filter.keywords]
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.GetClients()))
            }, [
              _hoisted_16
            ])
          ])
        ]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_17, [
            _createVNode("div", null, _toDisplayString(_ctx.$t('businessClient.total-clients')), 1),
            _createVNode("div", null, _toDisplayString(_ctx.$t('businessClient.total-result', [_ctx.totalFiltered, _ctx.total])), 1)
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("span", {
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
            }, _toDisplayString(_ctx.$t('button.showAll')), 1)
          ]),
          _createVNode("div", {
            class: ["business-clients-filter", { hasFilter: _ctx.hasFilter }]
          }, [
            _createVNode("button", {
              type: "button",
              class: "business-clients-filter-btn-text",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.ShowFilter && _ctx.ShowFilter(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
              _hoisted_19
            ]),
            (_ctx.hasFilter)
              ? (_openBlock(), _createBlock("div", _hoisted_20, "!"))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _createVNode("div", _hoisted_21, [
        _createVNode("table", _hoisted_22, [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              _createVNode("td", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sotrBy('Id')))
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('businessClients.Id')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Id')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sotrBy('Name')))
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('businessClients.name')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Name')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sotrBy('TotalOrders')))
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('businessClients.footer.amount-orders')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('TotalOrders')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sotrBy('TotalInvoice')))
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('businessClients.footer.total-invoice')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('TotalInvoice')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sotrBy('TotalReceipts')))
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('businessClients.footer.total-receipts')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('TotalReceipts')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sotrBy('TotalInvoicesLeftToBind')))
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('businessClients.footer.total-invoices-left-to-bind')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('TotalInvoicesLeftToBind')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sotrBy('Balance')))
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('orders.balance')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Balance')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.sotrBy('AccountingSystemCode')))
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('businessClient.accounting-system-code')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('AccountingSystemCode')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sotrBy('Mobile')))
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('label.mobile')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Mobile')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.sotrBy('Email')))
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('label.email')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Email')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", {
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.sotrBy('Status'))),
                style: {"min-width":"150px!important"}
              }, [
                _createVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('title.status')) + " ", 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Status')]
                  }, null, 2)
                ])
              ]),
              _createVNode("td", _hoisted_23, [
                _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('label.action')), 1)
              ])
            ])
          ]),
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.businessClients, (row, index) => {
              return (_openBlock(), _createBlock("tr", {
                key: index,
                class: ["client-item", row.active === false ? 'deactivated-marker' : '']
              }, [
                _createVNode("td", {
                  class: "text-link",
                  onClick: ($event: any) => (_ctx.goToDetails(row.id))
                }, _toDisplayString(row.id), 9, ["onClick"]),
                _createVNode("td", {
                  class: "text-link no-underline",
                  onClick: ($event: any) => (_ctx.goToDetails(row.id))
                }, _toDisplayString(row.name), 9, ["onClick"]),
                _createVNode("td", _hoisted_25, _toDisplayString(_ctx.formatAmount(row.totalOrders)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1),
                _createVNode("td", _hoisted_26, _toDisplayString(_ctx.formatAmount(row.totalInvoice)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1),
                _createVNode("td", _hoisted_27, _toDisplayString(_ctx.formatAmount(row.totalReceipts)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1),
                _createVNode("td", _hoisted_28, _toDisplayString(_ctx.formatAmount(row.totalInvoicesLeftToBind)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1),
                _createVNode("td", _hoisted_29, _toDisplayString(_ctx.formatAmount(row.balance)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1),
                _createVNode("td", null, _toDisplayString(row.accountingSystemCode), 1),
                _createVNode("td", _hoisted_30, [
                  _createVNode("span", _hoisted_31, [
                    _createVNode("a", {
                      class: "text-link",
                      href: 'tel:' + row.phone1
                    }, _toDisplayString(row.phone1), 9, ["href"])
                  ])
                ]),
                _createVNode("td", _hoisted_32, [
                  _createVNode("span", _hoisted_33, [
                    _createVNode("a", {
                      class: "mailto",
                      href: 'mailto:' + row.email
                    }, _toDisplayString(row.email), 9, ["href"])
                  ])
                ]),
                _createVNode("td", null, [
                  _createVNode("span", {
                    class: ["text-uppercase product-text", row.active ? 'active' : 'not-active']
                  }, _toDisplayString(row.active ? _ctx.$t('product.active') : _ctx.$t('product.notActive')), 3)
                ]),
                _createVNode("td", _hoisted_34, [
                  _createVNode("i", {
                    class: "icon-f icon-pencil-edit fs-16",
                    onClick: ($event: any) => (_ctx.goToDetails(row.id))
                  }, null, 8, ["onClick"])
                ])
              ], 2))
            }), 128))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_35, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.businessClients, (row, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "client-item"
          }, [
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('businessClients.Id')), 1),
              _createVNode("div", _hoisted_38, [
                _createVNode("span", {
                  class: "client-item-row-value-link",
                  onClick: ($event: any) => (_ctx.goToDetails(row.id))
                }, _toDisplayString(row.id), 9, ["onClick"])
              ])
            ]),
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('businessClients.name')), 1),
              _createVNode("div", _hoisted_41, [
                _createVNode("span", {
                  class: "client-item-row-value-link",
                  onClick: ($event: any) => (_ctx.goToDetails(row.id))
                }, _toDisplayString(row.name), 9, ["onClick"])
              ])
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('businessClients.footer.amount-orders')), 1),
              _createVNode("div", _hoisted_44, _toDisplayString(_ctx.formatAmount(row.totalOrders)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
            ]),
            _createVNode("div", _hoisted_45, [
              _createVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('businessClients.footer.total-invoice')), 1),
              _createVNode("div", _hoisted_47, _toDisplayString(_ctx.formatAmount(row.totalInvoice)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
            ]),
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('businessClients.footer.total-receipts')), 1),
              _createVNode("div", _hoisted_50, _toDisplayString(_ctx.formatAmount(row.totalReceipts)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
            ]),
            _createVNode("div", _hoisted_51, [
              _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('businessClients.footer.total-invoices-left-to-bind')), 1),
              _createVNode("div", _hoisted_53, _toDisplayString(_ctx.formatAmount(row.totalInvoicesLeftToBind)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
            ]),
            _createVNode("div", _hoisted_54, [
              _createVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('orders.balance')), 1),
              _createVNode("div", _hoisted_56, _toDisplayString(_ctx.formatAmount(row.balance)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1)
            ]),
            _createVNode("div", _hoisted_57, [
              _createVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('businessClient.accounting-system-code')), 1),
              _createVNode("div", _hoisted_59, _toDisplayString(row.accountingSystemCode), 1)
            ]),
            _createVNode("div", _hoisted_60, [
              _createVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('label.mobile')), 1),
              _createVNode("div", _hoisted_62, [
                _createVNode("a", {
                  class: "client-item-row-value-link",
                  href: 'tel:' + row.phone1
                }, _toDisplayString(row.phone1), 9, ["href"])
              ])
            ]),
            _createVNode("div", _hoisted_63, [
              _createVNode("div", _hoisted_64, [
                _createVNode("span", _hoisted_65, _toDisplayString(_ctx.$t('label.email')), 1)
              ]),
              _createVNode("div", _hoisted_66, [
                _createVNode("a", {
                  class: "mailto",
                  href: 'mailto:' + row.email
                }, _toDisplayString(row.email), 9, ["href"])
              ])
            ]),
            _createVNode("div", _hoisted_67, [
              _createVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('title.status')), 1),
              _createVNode("div", {
                class: ["client-item-row-value", row.active ? 'client-item-row-value-active' : 'client-item-row-value-notActive']
              }, _toDisplayString(row.active ? _ctx.$t('product.active') : _ctx.$t('product.notActive')), 3)
            ]),
            _createVNode("span", _hoisted_69, [
              _createVNode("i", {
                class: "icon-f icon-pencil-edit fs-16",
                onClick: ($event: any) => (_ctx.goToDetails(row.id))
              }, null, 8, ["onClick"])
            ])
          ]))
        }), 128))
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.loaded]
  ])
})